import script from "./BaseSidePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSidePanel.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSidePanel.vue?vue&type=style&index=0&id=76df3c74&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76df3c74"]])

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels,QTabPanel});
